import { useCallback } from 'react';
import { useAgentPanelStore } from './use-agent-panel-store';

/**
 * Header back chevron: step back inside the generator, or close the panel
 * when there is no prior step (compose / terminal phases).
 */
export const useGeneratorBack = () => {
  const close = useAgentPanelStore((s) => s.close);
  const generatorState = useAgentPanelStore((s) => s.generatorState);
  const setGeneratorState = useAgentPanelStore((s) => s.setGeneratorState);

  return useCallback(() => {
    if (!generatorState) {
      close();
      return;
    }

    switch (generatorState.phase) {
      case 'preview':
        setGeneratorState({
          phase: 'options',
          extracted: generatorState.extracted,
          options: generatorState.options,
          preselected: generatorState.preselected,
          selections: generatorState.selections,
          stagedRemovals: [],
          dayOverrides: generatorState.dayOverrides,
          recommendation: generatorState.recommendation,
          activeDayIndex: 0,
          activeCategory: 'accommodation',
          activeBuildStep: 'day-picks',
        });
        return;
      case 'budget':
        setGeneratorState({ ...generatorState, phase: 'preview' });
        return;
      default:
        close();
    }
  }, [close, generatorState, setGeneratorState]);
};
